export const GET_BRANDING_PAGE = `
  query Guideline {
    guideline {
      title
      contentMapped
      sidebarLinks {
        sections {
          label
          sectionId
        }
      }
    }
    sonnenEinstellungen {
      textSettings {
        branding {
          headline
        }
      }
    }
  }
`;
